import { render, staticRenderFns } from "./SelectDropdown.vue?vue&type=template&id=90384052"
import script from "./SelectDropdown.vue?vue&type=script&lang=js"
export * from "./SelectDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports